import { useMemo } from "react";
import { useCarouselCoursesContent } from "@tecnobit-srl/content-types-carousel-courses/lazy";
import { useCourseListContent } from "@tecnobit-srl/courses-content-types-course-list/lazy";
import { useCourseGalleryContent } from "@tecnobit-srl/courses-content-types-course-gallery/lazy";
import { useCourseGoalsContent } from "@tecnobit-srl/courses-content-types-course-goals/lazy";
import { useCourseSubscribeOptionsContent } from "@tecnobit-srl/courses-content-types-course-subscribe-options/lazy";
import { useCourseTrialContent } from "@tecnobit-srl/courses-content-types-course-trial/lazy";
import { useCourseTeachersContent } from "@tecnobit-srl/courses-content-types-course-teachers/lazy";
import { useCourseLessonsContent } from "@tecnobit-srl/courses-content-types-course-lessons/lazy";
import { useRelatedCoursesContent } from "@tecnobit-srl/courses-content-types-related-courses/lazy";
import { useCourseOptionsContent } from "@tecnobit-srl/courses-content-types-course-options/lazy";
import { useCoursesSearchContent } from "@tecnobit-srl/courses-content-types-courses-search/lazy";
import { useCoursesSortingContent } from "@tecnobit-srl/courses-content-types-courses-sorting/lazy";
import { useCoursesFilterContent } from "@tecnobit-srl/courses-content-types-courses-filter/lazy";
import { useCourseModalitiesContent } from "@tecnobit-srl/courses-content-types-course-modalities/lazy";
import { useCoursesReviewsContent } from "@tecnobit-srl/courses-content-types-courses-reviews/lazy";
import { useCourseAlertContent } from "@tecnobit-srl/courses-content-types-course-alert/lazy";
import { useCourseCertificateButtonContent } from "@tecnobit-srl/courses-content-types-course-certificate-button/lazy";
import { useCourseProgressContent } from "@tecnobit-srl/courses-content-types-course-progress/lazy";
import { useCourseLessonQuizContent } from "@tecnobit-srl/courses-content-types-course-lesson-quiz/lazy";
import { useCourseLessonMenuContent } from "@tecnobit-srl/courses-content-types-course-lesson-menu/lazy";
import { useCourseLessonPaginatorContent } from "@tecnobit-srl/courses-content-types-course-lesson-paginator/lazy";
import { useCourseLessonVideoContent } from "@tecnobit-srl/courses-content-types-course-lesson-video/lazy";
import { useCourseLessonMaterialsContent } from "@tecnobit-srl/courses-content-types-course-lesson-materials/lazy";
//#region src/index.ts
var useCoursesContentTypes = () => {
	const carouselCourses = useCarouselCoursesContent();
	const courseList = useCourseListContent();
	const courseGallery = useCourseGalleryContent();
	const courseGoals = useCourseGoalsContent();
	const courseSubscribeOptions = useCourseSubscribeOptionsContent();
	const courseTrial = useCourseTrialContent();
	const courseTeachers = useCourseTeachersContent();
	const courseLessons = useCourseLessonsContent();
	const relatedCourses = useRelatedCoursesContent();
	const courseOptions = useCourseOptionsContent();
	const coursesSearch = useCoursesSearchContent();
	const coursesSorting = useCoursesSortingContent();
	const coursesFilter = useCoursesFilterContent();
	const courseModalities = useCourseModalitiesContent();
	const courseReviews = useCoursesReviewsContent();
	const courseAlert = useCourseAlertContent();
	const courseCertificateButton = useCourseCertificateButtonContent();
	const courseProgress = useCourseProgressContent();
	const courseLessonQuiz = useCourseLessonQuizContent();
	const courseLessonMenu = useCourseLessonMenuContent();
	const courseLessonPaginator = useCourseLessonPaginatorContent();
	const courseLessonVideo = useCourseLessonVideoContent();
	const courseLessonMaterials = useCourseLessonMaterialsContent();
	return useMemo(() => ({
		...carouselCourses,
		...courseList,
		...courseGallery,
		...courseGoals,
		...courseSubscribeOptions,
		...courseTrial,
		...courseTeachers,
		...courseLessons,
		...relatedCourses,
		...courseOptions,
		...coursesSearch,
		...coursesSorting,
		...coursesFilter,
		...courseModalities,
		...courseReviews,
		...courseAlert,
		...courseCertificateButton,
		...courseProgress,
		...courseLessonQuiz,
		...courseLessonMenu,
		...courseLessonPaginator,
		...courseLessonVideo,
		...courseLessonMaterials
	}), [
		carouselCourses,
		courseList,
		courseGallery,
		courseGoals,
		courseSubscribeOptions,
		courseTrial,
		courseTeachers,
		courseLessons,
		relatedCourses,
		courseOptions,
		coursesSearch,
		coursesSorting,
		coursesFilter,
		courseModalities,
		courseReviews,
		courseAlert,
		courseCertificateButton,
		courseProgress,
		courseLessonQuiz,
		courseLessonMenu,
		courseLessonPaginator,
		courseLessonVideo,
		courseLessonMaterials
	]);
};
//#endregion
export { useCoursesContentTypes };
